import { PIPFormClient } from "./pipformclient";

export function delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export async function CreatePIPS(sid: string, TPAppXML: ajaxslt.XNode) {
    var item: ajaxslt.XNode = TPAppXML;
    var node: ajaxslt.XNode = item;
    var info: PIPFormClient.PIPInfo = PIPFormClient.ConvertOldTPAppXML(node);
    var lawyernode: ajaxslt.XNode = node.selectSingleNode('lawyer');
    var tpanode: ajaxslt.XNode = lawyernode ? lawyernode.selectSingleNode('ThirdPartyAcounts') : null;
    var tenode: ajaxslt.XNode = tpanode ? tpanode.selectSingleNode("Account[@Party='TeranetExpress']") : null;
    var tnode: ajaxslt.XNode = tpanode ? tpanode.selectSingleNode("Account[@Party='Teraview']") : null;
    var account: string = null;
    var password: string = null;

    if (tnode && tnode.getAttribute('Account') != null && tnode.getAttribute('Account') > '') {
        account = tnode.getAttribute('Account');
    }

    if (tenode && tenode.getAttribute('TVNumber') != null && tenode.getAttribute('TVNumber') > '') {
        password = tenode.getAttribute('TVNumber');
    }
    // validation
    var flagValidate: boolean = ValidatePIPS(info);
    if (!flagValidate) {
        return;
    }

    // server Call
    var missingFields = [];
    if (account == null || account == "")
        missingFields.push("Teraview Account");
    if (password == null || password == "")
        missingFields.push("TV Number");
    if (missingFields.length > 0) {
        var alertMSG = "Please enter the following required fields: \n";
        for (var _i = 0, missingFields_1 = missingFields; _i < missingFields_1.length; _i++) {
            var field = missingFields_1[_i];
            alertMSG += field + "\n";
        }
        alert(alertMSG);
        return;
    }
    var ret = await PIPFormClient.CreateNewForm(info, account, password, sid);
    if (ret > '') {
        node.setAttribute('PIPFormID', ret);
        return ret;
    }
    else if (ret != '') {
        alert('Form creation failed.\nPlease confirm that your file contains valid PIN(s), Transferee name(s), \nand birth date(s), then try again.');
    }
}

export function ValidatePIPS(info) {
    console.log("info", info);
    if (info.Purchasers.length == 0) {
        alert("At least one Purchaser is required.");
        return false;
    } else {
        for (var j = 0; j < info.Purchasers.length; j++) {
            if (info.Purchasers[j].EntityType == "1") {
                // Corporation Name 
                if (info.Purchasers[j].Name == "" || info.Purchasers[j].Name == null) {
                    alert("Name of Corporation is required");
                    return false;
                }
            }
            else {
                // First Name 
                if (info.Purchasers[j].FirstName == "" || info.Purchasers[j].FirstName == null) {
                    alert("First Name of Purchaser is required");
                    return false;
                }

                // Last Name 
                if (info.Purchasers[j].LastName == "" || info.Purchasers[j].LastName == null) {
                    alert("Last Name of Purchaser is required");
                    return false;
                }

                // Birth Date 
                if (info.Purchasers[j].BirthDate == "" || info.Purchasers[j].BirthDate == null) {
                    alert("Birth Date of Purchaser " + info.Purchasers[j].FirstName + " " + info.Purchasers[j].LastName + " is required");
                    return false;
                } else {
                    if (info.Purchasers[j].BirthDate.indexOf("-") > -1) {
                        // format birth date to yyyy/mm/dd
                        var birthDateArr = info.Purchasers[j].BirthDate.split("-");
                        var todayTime = new Date(birthDateArr[1] + "/" + birthDateArr[2] + "/" + birthDateArr[0]);
                        console.log("todayTime", todayTime.getFullYear() + '/' + ('0' + (todayTime.getMonth() + 1)).slice(-2) + '/' + ('0' + todayTime.getDate()).slice(-2));
                        info.Purchasers[j].BirthDate = todayTime.getFullYear() + '/' + ('0' + (todayTime.getMonth() + 1)).slice(-2) + '/' + ('0' + todayTime.getDate()).slice(-2);
                    }
                }
            }
        }
    }

    // validate Properties
    if (info.Properties.length == 0) {
        alert("At least one Property is required.");
        return false;
    } else {
        // validate PIN
        for (var i = 0; i < info.Properties.length; i++) {
            if (info.Properties[i].PINBlock == "" || info.Properties[i].PINBlock == null) {
                alert("PINBlock is required in Property");
                return false;
            }

            if (info.Properties[i].PINProperty == "" || info.Properties[i].PINProperty == null) {
                alert("PINProperty is required in Property");
                return false;
            }
        }
    }
    return true;
}

// whenever the form is transformed (add Property, add purchaser, etc)
export function removeHeaderFooter(iframe: HTMLIFrameElement, showiFrame: boolean) {
    try{
        iframe.contentWindow.document.querySelector('nav').style.display = 'none';
        iframe.contentWindow.document.querySelector('nav').style.overflowX = 'hidden';
        iframe.contentWindow.document.querySelector('header').style.display = 'none';
        iframe.contentWindow.document.getElementById('footer').style.display = 'none';
        if(showiFrame){
            iframe.style.height = iframe.contentWindow.document.body.scrollHeight+20 + 'px';
        }
    } catch (e){;}
}